import { css } from 'styled-system/css';

export const switchStyle = {
	textSwitch: css({
		_mars: {
			'--switch-tab-bg': '{colors.textSwitch.bg}',
			'--switch-tab-selected-bg': '{colors.brand.500}',
			rounded: '6px',
			boxShadow: '0 0 0 1px {colors.black.5} inset',
			md: {
				height: '30px',
			},

			_after: {
				rounded: '6px',
			}
		}
	}),
	textSwitchButton: css({
		_mars: {
			color: 'brand.500_light',
			'&[data-selected="true"]': {
				color: 'whiteOpacity.100',
			},
		}
	}),
	textSwitchText: css({
		_mars: {
			
		}
	}),
}